import React from "react";
import { Link } from "react-router-dom";

const ResourcesSection = () => {
  return (
    <div className="flex flex-col min-w-[152px] gap-4 border-l border-white pl-6">
      {/* Title */}
      <h2 className="text-white text-2xl font-[Axiforma] font-black mb-4">
        Resources
      </h2>

      {/* Links Container */}
      <div className="flex flex-col gap-2">
        <Link
          to="/privacy-policy"
          className="text-[#f2f2f2] text-base hover:text-white transition-colors"
        >
          Terms of Service & Privacy Policy
        </Link>
        <Link
          to="/refund-policy"
          className="text-[#f2f2f2] text-base hover:text-white transition-colors"
        >
          Refund And Payment Policies
        </Link>
        {/* <Link
          to="/terms-of-service"
          className="text-[#f2f2f2] text-base hover:text-white transition-colors"
        >
          Terms of service
        </Link> */}
      </div>
    </div>
  );
};

export default ResourcesSection;
